import Cookies from 'js-cookie';
import { getDomainData, getDomainStyles, getCurrentDomainId } from './staticDomainData';

/**
 * Get current domain ID from cookie or hostname
 * Returns just the domain ID number, not the full data object
 */
export const getDomainId = () => {
	try {
		const cookieData = Cookies.get('domain_id');
		if (cookieData) {
			// If it's a number string, parse it
			const parsed = parseInt(cookieData, 10);
			if (!isNaN(parsed)) {
				return parsed;
			}
			// If it's JSON (backward compatibility), try to parse
			try {
				const jsonData = JSON.parse(cookieData);
				return jsonData?.domain_id || getCurrentDomainId();
			} catch {
				return getCurrentDomainId();
			}
		}
		return getCurrentDomainId();
	} catch (error) {
		console.error('Error getting domain ID:', error);
		return getCurrentDomainId();
	}
};

/**
 * Get domain data object directly from static data
 * Returns the full domain data object
 */
export const getDomainDataFromStatic = (domainId = null) => {
	const id = domainId !== null ? domainId : getDomainId();
	return getDomainData(id);
};

/**
 * Get domain styles array directly from static data
 * Returns the styles array for the domain
 */
export const getDomainStylesFromStatic = (domainId = null) => {
	const id = domainId !== null ? domainId : getDomainId();
	return getDomainStyles(id);
};

/**
 * Get domain data in the old format (for backward compatibility)
 * Returns { domain_id: number, data: [domainData] }
 */
export const getDomainIdWithData = () => {
	const domainId = getDomainId();
	const domainData = getDomainData(domainId);
	return {
		domain_id: domainId,
		data: [domainData]
	};
};

